// import _ from 'lodash';
import showdown from 'showdown';
import config from '../config';

var converter = new showdown.Converter({ tables: 'true' });

/**
 * It takes a Strapi object and translates the markdown fields into HTML
 * @param textElements - the object containing the text elements to be translated
 * @returns the textElements object.
 */
export const translate = function(textElements) {
  Object.keys(textElements).forEach(elt => {
    if (config.MARKDOWN_FIELDS.includes(elt)) {
      textElements[elt] = converter.makeHtml(textElements[elt]);
    }
    // Image case
    if (elt == 'images') {
      textElements['images']['url'] = config.STRAPI_URL + textElements[elt]['url'];
    }
  });
  return textElements;
};
